import $ from 'jquery';

/**
 * Check /wwwroot/data/event-data-README.md for instructions
 */
$(function () {
  var $accordions = $('.accordion--events');
  if (!$accordions || !$accordions.length) {
    return;
  }
  fetch('data/event-data.json').then(function (response) {
    return response.json();
  }).then(onSuccess)["catch"](onError);

  ////

  function buildEvent(event) {
    var eventHTML = _buildEventHTML(event);
    var stateCode = event.location.replace(/[^,]+, ([A-Z][A-Z])[.]?/, '$1');
    if (event.location === 'Washington D.C.') {
      stateCode = 'DC';
    }
    if (!stateCode) {
      return;
    }
    var $eventsList = $('.state-list--' + stateCode.toLowerCase());
    if ($eventsList && $eventsList.length) {
      $eventsList.addClass('active');
      $eventsList.find('.events-list').append(eventHTML);
    }
    return;
  }
  function onError(error) {
    console.warn('Fetch Failed:', error);
  }
  function onSuccess(events) {
    events.forEach(buildEvent);
  }

  ////

  function _buildEventHTML(event) {
    var label = event.href ? "<a class=\"events-list-item__label\" href=\"".concat(event.href, "\" data-external-link>").concat(event.label || '', "</a>") : "<span class=\"events-list-item__label\">".concat(event.label || '', "</span>");
    var date = event.date ? event.date.replace(/ /g, '&nbsp;') : '';
    var location = event.location ? event.location.replace(/ /g, '&nbsp;') : '';
    return "\n            <li class=\"events-list-item\">\n                ".concat(label, "<br />\n                <span class=\"events-list-item__location\">").concat(location, "</span> | <span class=\"events-list-item__date\">").concat(date, "</span>\n            </li>\n        ");
  }
});